<template>
    <div class="pa-4">
        <TabsSliderContainer :tab.sync="tab" :items="items" />
    </div>
</template>
<script>
import TabsSliderContainer from '@/components/ui/TabsSliderContainer.vue';
import { mapActions } from 'vuex';

export default {
    name: 'ActsHome',
    components: { TabsSliderContainer },
    data: () => {
        return {
            tab: null,
            items: [
                { tab: 'Акты на отключение / подключение для юридических лиц', content: 'ContractsActs' },
                { tab: 'Акты на отключение / подключение для физических лиц ', content: 'AccountsActs' }
            ]
        };
    },
    methods: {
        ...mapActions('refs', ['getInspectors', 'getInjuctions', 'getReasons', 'getActions', 'getShutdown', 'getHeatingSystem', 'getJobPositionTypes'])
    },
    async mounted() {
        await this.getInspectors();
        await this.getInjuctions();
        await this.getReasons();
        await this.getActions();
        await this.getShutdown();
        await this.getHeatingSystem();
        await this.getJobPositionTypes();
    }
};
</script>

<style scoped></style>
